module.exports = __webpack_public_path__ + "assets/fonts/MiloOffc-Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/milo-medium/MiloOffc-Medium.eot
// module id = 517
// module chunks = 0